import { RoutedTabs } from 'components';

export const Centres = () => (
  <RoutedTabs
    tabsConfig={[
      { menuItem: { content: 'Centres', icon: 'building' }, path: 'centres' },
      { menuItem: { content: 'Locations', icon: 'location arrow' }, path: 'locations' },
    ]}
  />
);
